/**
 * Illustrative Change History seed rows — cover modules wired into central history.
 * Not live Rules, roles or settings.
 */

import { CHANGE_HISTORY_DISPLAY } from './changeHistoryEntry';

const NA = CHANGE_HISTORY_DISPLAY.NOT_APPLICABLE;
const NEW_ITEM = CHANGE_HISTORY_DISPLAY.NOT_APPLICABLE_NEW_ITEM;

export const CHANGE_HISTORY_SEED_SEQUENCE = 10520;

/** Newest first. */
export const CHANGE_HISTORY_SEED_ENTRIES = [
  {
    changeId: 'CHG-010520',
    changedOn: '11 Aug 2026, 5:40 pm',
    changedOnIso: '2026-08-11T17:40:00',
    module: 'Posts',
    changedItem: 'Kitchen Renovation Specialist',
    itemId: 'POST-004812',
    changeType: 'Publish',
    previousValues: NA,
    newValues: NA,
    changeReason: CHANGE_HISTORY_DISPLAY.NOT_REQUIRED,
    changedBy: 'Business — Jordan Lee',
    activityDetails: 'Post published successfully',
    sourceChangeRef: 'posts_management::POST-004812::Publish::2026-08-11T17:40:00',
    sourceModuleRef: 'posts_management',
    sourceItemRef: 'POST-004812',
  },
  {
    changeId: 'CHG-010519',
    changedOn: '11 Aug 2026, 5:10 pm',
    changedOnIso: '2026-08-11T17:10:00',
    module: 'Trade Categories',
    changedItem: 'Electrical',
    itemId: 'TC-0003',
    changeType: 'Edit',
    previousValues: 'Trade Category: Electrical\nSubcategories: Domestic; Commercial',
    newValues: 'Trade Category: Electrical\nSubcategories: Domestic; Commercial; Industrial',
    changeReason: 'Add Industrial as a public-facing subcategory',
    changedBy: 'Platform Owner — Saim Sahi',
    activityDetails: NA,
    sourceChangeRef: 'trade_categories_management::TC-0003::Edit::2026-08-11T17:10:00',
    sourceModuleRef: 'trade_categories_management',
    sourceItemRef: 'TC-0003',
  },
  {
    changeId: 'CHG-010518',
    changedOn: '11 Aug 2026, 4:45 pm',
    changedOnIso: '2026-08-11T16:45:00',
    module: 'Pricing Plans',
    changedItem: 'Pro Plan',
    itemId: 'PP-PRO',
    changeType: 'Edit',
    previousValues: 'currentMonthlyCost: 49\npendingMonthlyCost: None',
    newValues: 'currentMonthlyCost: 49\npendingMonthlyCost: 59',
    changeReason: 'Schedule confirmed Pro price change',
    changedBy: 'Platform Owner — Saim Sahi',
    activityDetails: NA,
    sourceChangeRef: 'pricing_plans::PP-PRO::Edit::2026-08-11T16:45:00',
    sourceModuleRef: 'pricing_plans',
    sourceItemRef: 'PP-PRO',
  },
  {
    changeId: 'CHG-010517',
    changedOn: '11 Aug 2026, 4:20 pm',
    changedOnIso: '2026-08-11T16:20:00',
    module: 'Billing & Subscriptions',
    changedItem: 'BUS-000214',
    itemId: 'BUS-000214',
    changeType: 'Note added',
    previousValues: NA,
    newValues: NA,
    changeReason: CHANGE_HISTORY_DISPLAY.NOT_REQUIRED,
    changedBy: 'Team Member — Olivia Brown',
    activityDetails: 'Olivia Brown; internal note added',
    sourceChangeRef: 'billing_subscriptions::BUS-000214::Note added::2026-08-11T16:20:00',
    sourceModuleRef: 'billing_subscriptions',
    sourceItemRef: 'BUS-000214',
    accountRef: 'BUS-000214',
  },
  {
    changeId: 'CHG-010516',
    changedOn: '11 Aug 2026, 3:55 pm',
    changedOnIso: '2026-08-11T15:55:00',
    module: 'Reviews',
    changedItem: 'RVW-000091',
    itemId: 'RVW-000091',
    changeType: 'Note added',
    previousValues: NA,
    newValues: NA,
    changeReason: CHANGE_HISTORY_DISPLAY.NOT_REQUIRED,
    changedBy: 'Rachel Brown',
    activityDetails: 'Rachel Brown; Quality',
    sourceChangeRef: 'reviews_management::RVW-000091::Note added::2026-08-11T15:55:00',
    sourceModuleRef: 'reviews_management',
    sourceItemRef: 'RVW-000091',
  },
  {
    changeId: 'CHG-010515',
    changedOn: '11 Aug 2026, 3:30 pm',
    changedOnIso: '2026-08-11T15:30:00',
    module: 'Moderation',
    changedItem: 'MOD-000412',
    itemId: 'MOD-000412',
    changeType: 'Final decision',
    previousValues: NA,
    newValues: NA,
    changeReason: CHANGE_HISTORY_DISPLAY.NOT_REQUIRED,
    changedBy: 'Support Team — Alex Morgan',
    activityDetails: 'Alex Morgan; Hide Content recorded; applied: Hide',
    sourceChangeRef: 'moderation::MOD-000412::Final decision::2026-08-11T15:30:00',
    sourceModuleRef: 'moderation',
    sourceItemRef: 'MOD-000412',
    caseRef: 'MOD-000412',
  },
  {
    changeId: 'CHG-010514',
    changedOn: '11 Aug 2026, 3:28 pm',
    changedOnIso: '2026-08-11T15:28:00',
    module: 'Posts',
    changedItem: 'Bathroom Remodel Offer',
    itemId: 'POST-004701',
    changeType: 'Take Down',
    previousValues: NA,
    newValues: NA,
    changeReason: CHANGE_HISTORY_DISPLAY.NOT_REQUIRED,
    changedBy: 'Support Team — Alex Morgan',
    activityDetails: 'Hide applied via Moderation',
    sourceChangeRef: 'posts_management::POST-004701::Take Down::2026-08-11T15:28:00',
    sourceModuleRef: 'posts_management',
    sourceItemRef: 'POST-004701',
  },
  {
    changeId: 'CHG-010513',
    changedOn: '11 Aug 2026, 2:50 pm',
    changedOnIso: '2026-08-11T14:50:00',
    module: 'Appeals',
    changedItem: 'APL-000088',
    itemId: 'APL-000088',
    changeType: 'Review started',
    previousValues: NA,
    newValues: NA,
    changeReason: CHANGE_HISTORY_DISPLAY.NOT_REQUIRED,
    changedBy: 'Support Team — Priya Shah',
    activityDetails: 'Priya Shah; New → In Progress',
    sourceChangeRef: 'appeals::APL-000088::Review started::2026-08-11T14:50:00',
    sourceModuleRef: 'appeals',
    sourceItemRef: 'APL-000088',
    caseRef: 'APL-000088',
  },
  {
    changeId: 'CHG-010512',
    changedOn: '11 Aug 2026, 2:20 pm',
    changedOnIso: '2026-08-11T14:20:00',
    module: 'Compliance',
    changedItem: 'CMP-000155',
    itemId: 'CMP-000155',
    changeType: 'Final decision',
    previousValues: NA,
    newValues: NA,
    changeReason: CHANGE_HISTORY_DISPLAY.NOT_REQUIRED,
    changedBy: 'Configuration Admin — Olivia Brown',
    activityDetails: 'Olivia Brown; Approved; Create Record',
    sourceChangeRef: 'compliance::CMP-000155::Final decision::2026-08-11T14:20:00',
    sourceModuleRef: 'compliance',
    sourceItemRef: 'CMP-000155',
    caseRef: 'CMP-000155',
  },
  {
    changeId: 'CHG-010511',
    changedOn: '11 Aug 2026, 1:55 pm',
    changedOnIso: '2026-08-11T13:55:00',
    module: 'Fraud & Security',
    changedItem: 'FRD-000067',
    itemId: 'FRD-000067',
    changeType: 'Status changed',
    previousValues: NA,
    newValues: NA,
    changeReason: CHANGE_HISTORY_DISPLAY.NOT_REQUIRED,
    changedBy: 'Security — Riley Chen',
    activityDetails: 'Riley Chen; In Progress → Decided',
    sourceChangeRef: 'fraud_security::FRD-000067::Status changed::2026-08-11T13:55:00',
    sourceModuleRef: 'fraud_security',
    sourceItemRef: 'FRD-000067',
    caseRef: 'FRD-000067',
  },
  {
    changeId: 'CHG-010510',
    changedOn: '11 Aug 2026, 1:25 pm',
    changedOnIso: '2026-08-11T13:25:00',
    module: 'Support Tickets',
    changedItem: 'ST-000183',
    itemId: 'ST-000183',
    changeType: 'Status changed',
    previousValues: NA,
    newValues: NA,
    changeReason: CHANGE_HISTORY_DISPLAY.NOT_REQUIRED,
    changedBy: 'Support Team — Priya Shah',
    activityDetails: 'Priya Shah; New → In Progress',
    sourceChangeRef: 'support_tickets::ST-000183::Status changed::2026-08-11T13:25:00',
    sourceModuleRef: 'support_tickets',
    sourceItemRef: 'ST-000183',
    ticketRef: 'ST-000183',
  },
  {
    changeId: 'CHG-010509',
    changedOn: '11 Aug 2026, 12:40 pm',
    changedOnIso: '2026-08-11T12:40:00',
    module: 'Businesses',
    changedItem: 'BUS-000214',
    itemId: 'BUS-000214',
    changeType: 'Profile updated',
    previousValues: NA,
    newValues: NA,
    changeReason: CHANGE_HISTORY_DISPLAY.NOT_REQUIRED,
    changedBy: 'Support Team — Alex Morgan',
    activityDetails: 'Alex Morgan; trading name confirmed',
    sourceChangeRef: 'businesses::BUS-000214::Profile updated::2026-08-11T12:40:00',
    sourceModuleRef: 'businesses',
    sourceItemRef: 'BUS-000214',
    accountRef: 'BUS-000214',
  },
  {
    changeId: 'CHG-010508',
    changedOn: '11 Aug 2026, 12:05 pm',
    changedOnIso: '2026-08-11T12:05:00',
    module: 'Customers',
    changedItem: 'CUS-000902',
    itemId: 'CUS-000902',
    changeType: 'Account status changed',
    previousValues: NA,
    newValues: NA,
    changeReason: CHANGE_HISTORY_DISPLAY.NOT_REQUIRED,
    changedBy: 'Support Team — Priya Shah',
    activityDetails: 'Priya Shah; Active → Restricted',
    sourceChangeRef: 'customers::CUS-000902::Account status changed::2026-08-11T12:05:00',
    sourceModuleRef: 'customers',
    sourceItemRef: 'CUS-000902',
    accountRef: 'CUS-000902',
  },
  {
    changeId: 'CHG-010507',
    changedOn: '11 Aug 2026, 11:30 am',
    changedOnIso: '2026-08-11T11:30:00',
    module: 'Team Members',
    changedItem: 'Olivia Brown',
    itemId: 'TM-0002',
    changeType: 'Edit',
    previousValues: 'role: Support Officer\nstatus: Active',
    newValues: 'role: Configuration Admin\nstatus: Active',
    changeReason: 'Promote to Configuration Admin after approval',
    changedBy: 'Platform Owner — Saim Sahi',
    activityDetails: NA,
    sourceChangeRef: 'team_members::TM-0002::Edit::2026-08-11T11:30:00',
    sourceModuleRef: 'team_members',
    sourceItemRef: 'TM-0002',
  },
  {
    changeId: 'CHG-010506',
    changedOn: '11 Aug 2026, 11:00 am',
    changedOnIso: '2026-08-11T11:00:00',
    module: 'Licences, Badges & Tickets',
    changedItem: 'Electrical Contractor Licence',
    itemId: 'LBT-SRC-0012',
    changeType: 'Edit',
    previousValues: 'itemStatus: Active\niconLabel: Electrical icon',
    newValues: 'itemStatus: Active\niconLabel: Electrical contractor icon',
    changeReason: 'Refresh public icon label',
    changedBy: 'Configuration Admin — Olivia Brown',
    activityDetails: NA,
    sourceChangeRef: 'compliance_items_management::LBT-SRC-0012::Edit::2026-08-11T11:00:00',
    sourceModuleRef: 'compliance_items_management',
    sourceItemRef: 'LBT-SRC-0012',
  },
  {
    changeId: 'CHG-010505',
    changedOn: '11 Aug 2026, 10:35 am',
    changedOnIso: '2026-08-11T10:35:00',
    module: 'Form Inventory',
    changedItem: 'Business Profile Required Fields',
    itemId: 'FIC-0008',
    changeType: 'Add',
    previousValues: NEW_ITEM,
    newValues: 'ruleName: Business Profile Required Fields\nruleStatus: Active',
    changeReason: 'Add confirmed Form Inventory configuration rule',
    changedBy: 'Platform Owner — Saim Sahi',
    activityDetails: NA,
    sourceChangeRef: 'form_inventory::FIC-0008::Add::2026-08-11T10:35:00',
    sourceModuleRef: 'form_inventory',
    sourceItemRef: 'FIC-0008',
  },
  {
    changeId: 'CHG-010504',
    changedOn: '11 Aug 2026, 10:05 am',
    changedOnIso: '2026-08-11T10:05:00',
    module: 'Keywords',
    changedItem: 'emergency plumber',
    itemId: 'KW-0144',
    changeType: 'Edit',
    previousValues: 'status: Active\nmatchType: Exact',
    newValues: 'status: Active\nmatchType: Phrase',
    changeReason: 'Allow phrase matching for emergency searches',
    changedBy: 'Development — Alex Morgan',
    activityDetails: NA,
    sourceChangeRef: 'keywords_management::KW-0144::Edit::2026-08-11T10:05:00',
    sourceModuleRef: 'keywords_management',
    sourceItemRef: 'KW-0144',
  },
  {
    changeId: 'CHG-010503',
    changedOn: '11 Aug 2026, 9:40 am',
    changedOnIso: '2026-08-11T09:40:00',
    module: 'Configuration — Search Matching',
    changedItem: 'Platform Default Search',
    itemId: 'SMR-0001',
    changeType: 'Edit',
    previousValues: 'defaultSearchRadius: 10\nvisitorSearchAccess: true',
    newValues: 'defaultSearchRadius: 15\nvisitorSearchAccess: true',
    changeReason: 'Widen default radius after search quality review',
    changedBy: 'Development — Alex Morgan',
    activityDetails: NA,
    sourceChangeRef: 'configuration_search_matching::SMR-0001::Edit::2026-08-11T09:40:00',
    sourceModuleRef: 'configuration_search_matching',
    sourceItemRef: 'SMR-0001',
  },
  {
    changeId: 'CHG-010502',
    changedOn: '11 Aug 2026, 9:10 am',
    changedOnIso: '2026-08-11T09:10:00',
    module: 'Configuration — Quote Matching & Distribution',
    changedItem: 'Standard Quote Distribution',
    itemId: 'QMD-0002',
    changeType: 'Edit',
    previousValues: 'priority: 2\nmaxRecipients: 5',
    newValues: 'priority: 1\nmaxRecipients: 8',
    changeReason: 'Increase distribution for standard quote requests',
    changedBy: 'Configuration Admin — Olivia Brown',
    activityDetails: NA,
    sourceChangeRef: 'configuration_quote_matching::QMD-0002::Edit::2026-08-11T09:10:00',
    sourceModuleRef: 'configuration_quote_matching',
    sourceItemRef: 'QMD-0002',
  },
  {
    changeId: 'CHG-010501',
    changedOn: '10 Aug 2026, 6:50 pm',
    changedOnIso: '2026-08-10T18:50:00',
    module: 'Configuration — Compliance',
    changedItem: 'Licence Evidence Rule',
    itemId: 'CPL-0004',
    changeType: 'Edit',
    previousValues: 'evidenceRequirement: Optional\nexpiryApplies: Yes',
    newValues: 'evidenceRequirement: Required\nexpiryApplies: Yes',
    changeReason: 'Require evidence for licence applications',
    changedBy: 'Configuration Admin — Olivia Brown',
    activityDetails: NA,
    sourceChangeRef: 'configuration_compliance::CPL-0004::Edit::2026-08-10T18:50:00',
    sourceModuleRef: 'configuration_compliance',
    sourceItemRef: 'CPL-0004',
  },
  {
    changeId: 'CHG-010500',
    changedOn: '10 Aug 2026, 6:20 pm',
    changedOnIso: '2026-08-10T18:20:00',
    module: 'Configuration — Flag',
    changedItem: 'System Post Spam Match',
    itemId: 'FLG-0003',
    changeType: 'Edit',
    previousValues: 'severity: Low\nconditions: Issue · Equals · Spam or Unwanted Promotion',
    newValues: 'severity: Medium\nconditions: Issue · Equals · Spam or Unwanted Promotion; Match Classification · Equals · Confirmed Match',
    changeReason: 'Linked confirmed spam findings on Posts to Moderation.',
    changedBy: 'Configuration Admin — Olivia Brown',
    activityDetails: NA,
    sourceChangeRef: 'configuration_flag::FLG-0003::Edit::2026-08-10T18:20:00',
    sourceModuleRef: 'configuration_flag',
    sourceItemRef: 'FLG-0003',
  },
  {
    changeId: 'CHG-010499',
    changedOn: '10 Aug 2026, 5:55 pm',
    changedOnIso: '2026-08-10T17:55:00',
    module: 'Configuration — Lifecycle',
    changedItem: 'Draft Post Ageing',
    itemId: 'LCR-0002',
    changeType: 'Add',
    previousValues: NEW_ITEM,
    newValues: 'ruleName: Draft Post Ageing\nstatus: Active',
    changeReason: 'Add ageing rule for unused drafts',
    changedBy: 'Configuration Admin — Olivia Brown',
    activityDetails: NA,
    sourceChangeRef: 'configuration_lifecycle::LCR-0002::Add::2026-08-10T17:55:00',
    sourceModuleRef: 'configuration_lifecycle',
    sourceItemRef: 'LCR-0002',
  },
  {
    changeId: 'CHG-010498',
    changedOn: '10 Aug 2026, 5:30 pm',
    changedOnIso: '2026-08-10T17:30:00',
    module: 'Configuration — Workflow',
    changedItem: 'Support Ticket Intake',
    itemId: 'WFR-0006',
    changeType: 'Edit',
    previousValues: 'priority: Medium\nstatus: Active',
    newValues: 'priority: High\nstatus: Active',
    changeReason: 'Raise intake priority for account issues',
    changedBy: 'Configuration Admin — Olivia Brown',
    activityDetails: NA,
    sourceChangeRef: 'configuration_workflow::WFR-0006::Edit::2026-08-10T17:30:00',
    sourceModuleRef: 'configuration_workflow',
    sourceItemRef: 'WFR-0006',
  },
  {
    changeId: 'CHG-010497',
    changedOn: '10 Aug 2026, 5:05 pm',
    changedOnIso: '2026-08-10T17:05:00',
    module: 'Configuration — Case Actions',
    changedItem: 'Moderation Hide Content',
    itemId: 'CAR-0011',
    changeType: 'Edit',
    previousValues: 'actionType: hide\nstatus: Active',
    newValues: 'actionType: hide\nstatus: Inactive',
    changeReason: 'Pause hide action pending policy review',
    changedBy: 'Platform Owner — Saim Sahi',
    activityDetails: NA,
    sourceChangeRef: 'configuration_case_actions::CAR-0011::Edit::2026-08-10T17:05:00',
    sourceModuleRef: 'configuration_case_actions',
    sourceItemRef: 'CAR-0011',
  },
  {
    changeId: 'CHG-010496',
    changedOn: '10 Aug 2026, 4:40 pm',
    changedOnIso: '2026-08-10T16:40:00',
    module: 'Configuration — Content Controls',
    changedItem: 'External Link Block',
    itemId: 'CCR-0007',
    changeType: 'Edit',
    previousValues: 'contentIssue: External Link\nstatus: Active',
    newValues: 'contentIssue: External Link\nstatus: Active',
    changeReason: 'Clarify blocked domains list',
    changedBy: 'Development — Alex Morgan',
    activityDetails: NA,
    sourceChangeRef: 'configuration_content_controls::CCR-0007::Edit::2026-08-10T16:40:00',
    sourceModuleRef: 'configuration_content_controls',
    sourceItemRef: 'CCR-0007',
  },
  {
    changeId: 'CHG-010495',
    changedOn: '10 Aug 2026, 4:10 pm',
    changedOnIso: '2026-08-10T16:10:00',
    module: 'Configuration — Appeals',
    changedItem: 'Standard Appeal Window',
    itemId: 'APL-CFG-0001',
    changeType: 'Edit',
    previousValues: 'appealWindowDays: 7\nstatus: Active',
    newValues: 'appealWindowDays: 14\nstatus: Active',
    changeReason: 'Extend appeal window to fourteen days',
    changedBy: 'Platform Owner — Saim Sahi',
    activityDetails: NA,
    sourceChangeRef: 'configuration_appeals::APL-CFG-0001::Edit::2026-08-10T16:10:00',
    sourceModuleRef: 'configuration_appeals',
    sourceItemRef: 'APL-CFG-0001',
  },
  {
    changeId: 'CHG-010494',
    changedOn: '10 Aug 2026, 3:45 pm',
    changedOnIso: '2026-08-10T15:45:00',
    module: 'Configuration — Notifications',
    changedItem: 'Ticket Assigned Email',
    itemId: 'NRL-0003',
    changeType: 'Edit',
    previousValues: 'deliveryMethod: Email\nstatus: Active',
    newValues: 'deliveryMethod: Email; Dashboard\nstatus: Active',
    changeReason: 'Also notify in Dashboard when tickets are assigned',
    changedBy: 'Configuration Admin — Olivia Brown',
    activityDetails: NA,
    sourceChangeRef: 'configuration_notifications::NRL-0003::Edit::2026-08-10T15:45:00',
    sourceModuleRef: 'configuration_notifications',
    sourceItemRef: 'NRL-0003',
  },
  {
    changeId: 'CHG-010493',
    changedOn: '10 Aug 2026, 3:20 pm',
    changedOnIso: '2026-08-10T15:20:00',
    module: 'Configuration — Automation',
    changedItem: 'Nightly Cleanup',
    itemId: 'AUT-0001',
    changeType: 'Edit',
    previousValues: 'schedule: Daily 01:00\nstatus: Active',
    newValues: 'schedule: Daily 02:00\nstatus: Active',
    changeReason: 'Shift automation window after maintenance',
    changedBy: 'Development — Alex Morgan',
    activityDetails: NA,
    sourceChangeRef: 'configuration_automation::AUT-0001::Edit::2026-08-10T15:20:00',
    sourceModuleRef: 'configuration_automation',
    sourceItemRef: 'AUT-0001',
  },
  {
    changeId: 'CHG-010492',
    changedOn: '10 Aug 2026, 2:50 pm',
    changedOnIso: '2026-08-10T14:50:00',
    module: 'Configuration — Publishing',
    changedItem: 'Post Publish Gate',
    itemId: 'PUB-0002',
    changeType: 'Edit',
    previousValues: 'requireReview: false\nstatus: Active',
    newValues: 'requireReview: true\nstatus: Active',
    changeReason: 'Require review before first publish for new Businesses',
    changedBy: 'Platform Owner — Saim Sahi',
    activityDetails: NA,
    sourceChangeRef: 'configuration_publishing::PUB-0002::Edit::2026-08-10T14:50:00',
    sourceModuleRef: 'configuration_publishing',
    sourceItemRef: 'PUB-0002',
  },
  {
    changeId: 'CHG-010491',
    changedOn: '10 Aug 2026, 2:20 pm',
    changedOnIso: '2026-08-10T14:20:00',
    module: 'Configuration — Validation',
    changedItem: 'ABN Format Check',
    itemId: 'VAL-0005',
    changeType: 'Edit',
    previousValues: 'severity: Warning\nstatus: Active',
    newValues: 'severity: Error\nstatus: Active',
    changeReason: 'Block invalid ABN submissions',
    changedBy: 'Development — Alex Morgan',
    activityDetails: NA,
    sourceChangeRef: 'configuration_validation::VAL-0005::Edit::2026-08-10T14:20:00',
    sourceModuleRef: 'configuration_validation',
    sourceItemRef: 'VAL-0005',
  },
  {
    changeId: 'CHG-010490',
    changedOn: '10 Aug 2026, 1:50 pm',
    changedOnIso: '2026-08-10T13:50:00',
    module: 'Support Tickets',
    changedItem: 'General Enquiry',
    itemId: 'STK-0001',
    changeType: 'Edit',
    previousValues: 'automaticPriority: Medium\nvisitorAvailable: true',
    newValues: 'automaticPriority: Low\nvisitorAvailable: true',
    changeReason: 'Lower default priority for general enquiries',
    changedBy: 'Configuration Admin — Olivia Brown',
    activityDetails: NA,
    sourceChangeRef: 'support_ticket_configuration::STK-0001::Edit::2026-08-10T13:50:00',
    sourceModuleRef: 'support_ticket_configuration',
    sourceItemRef: 'STK-0001',
  },
  {
    changeId: 'CHG-010489',
    changedOn: '10 Aug 2026, 1:20 pm',
    changedOnIso: '2026-08-10T13:20:00',
    module: 'Fraud & Security',
    changedItem: 'Business Review',
    itemId: 'FSR-0001',
    changeType: 'Edit',
    previousValues: 'restriction: Required\nduration: 7 Days',
    newValues: 'restriction: Required\nduration: 14 Days',
    changeReason: 'Extend default restriction duration',
    changedBy: 'Security — Riley Chen',
    activityDetails: NA,
    sourceChangeRef: 'fraud_security::FSR-0001::Edit::2026-08-10T13:20:00',
    sourceModuleRef: 'fraud_security',
    sourceItemRef: 'FSR-0001',
  },
  {
    changeId: 'CHG-010488',
    changedOn: '10 Aug 2026, 12:45 pm',
    changedOnIso: '2026-08-10T12:45:00',
    module: 'Configuration — Keywords',
    changedItem: 'Keyword Matching Defaults',
    itemId: 'KWC-0001',
    changeType: 'Edit',
    previousValues: 'typoHandling: Off\nuseInactiveKeywords: false',
    newValues: 'typoHandling: limited_spelling_tolerance\nuseInactiveKeywords: false',
    changeReason: 'Enable limited spelling tolerance',
    changedBy: 'Development — Alex Morgan',
    activityDetails: NA,
    sourceChangeRef: 'configuration_keywords::KWC-0001::Edit::2026-08-10T12:45:00',
    sourceModuleRef: 'configuration_keywords',
    sourceItemRef: 'KWC-0001',
  },
  {
    changeId: 'CHG-010487',
    changedOn: '10 Aug 2026, 12:10 pm',
    changedOnIso: '2026-08-10T12:10:00',
    module: 'Settings',
    changedItem: 'Branding — Platform Display Name',
    itemId: NA,
    changeType: 'Edit',
    previousValues: 'Display Name: TradesPoster',
    newValues: 'Display Name: Trades Poster',
    changeReason: 'Align display name with brand guidelines',
    changedBy: 'Platform Owner — Saim Sahi',
    activityDetails: NA,
    sourceChangeRef: 'settings::branding_display_name::Edit::2026-08-10T12:10:00',
    sourceModuleRef: 'settings',
    sourceItemRef: 'branding_display_name',
  },
  {
    changeId: 'CHG-010486',
    changedOn: '10 Aug 2026, 4:25 pm',
    changedOnIso: '2026-08-10T16:25:00',
    module: 'Configuration — Limits & Thresholds',
    changedItem: 'Pro Post Allowance',
    itemId: 'LTH-0105',
    changeType: 'Edit',
    previousValues: 'Allowed Maximum: 4 Posts',
    newValues: 'Allowed Maximum: 5 Posts',
    changeReason: 'Align the Pro allowance with the confirmed plan',
    changedBy: 'Platform Owner — Saim Sahi',
    activityDetails: NA,
    sourceChangeRef: 'limits::LTH-0105::Edit::2026-08-10T16:25:00',
    sourceModuleRef: 'configuration_limits',
    sourceItemRef: 'LTH-0105',
  },
  {
    changeId: 'CHG-010485',
    changedOn: '10 Aug 2026, 3:50 pm',
    changedOnIso: '2026-08-10T15:50:00',
    module: 'Configuration — Retention',
    changedItem: 'Customer Account Closure',
    itemId: 'RET-0001',
    changeType: 'Edit',
    previousValues: 'Retention Period: 90 Days',
    newValues: 'Retention Period: 120 Days',
    changeReason: 'Apply the confirmed closed Customer account retention period',
    changedBy: 'Platform Owner — Saim Sahi',
    activityDetails: NA,
    sourceChangeRef: 'retention::RET-0001::Edit::2026-08-10T15:50:00',
    sourceModuleRef: 'configuration_retention',
    sourceItemRef: 'RET-0001',
  },
  {
    changeId: 'CHG-010484',
    changedOn: '10 Aug 2026, 2:55 pm',
    changedOnIso: '2026-08-10T14:55:00',
    module: 'Configuration — Routing',
    changedItem: 'Account Issue Ticket Routing',
    itemId: 'RR-0001',
    changeType: 'Edit',
    previousValues: 'Conditions: Issue Type · Equals · General Enquiry',
    newValues: 'Conditions: Issue Type · Equals · Account Issue',
    changeReason: 'Correct the Account Issue routing Condition',
    changedBy: 'Development — Alex Morgan',
    activityDetails: NA,
    sourceChangeRef: 'routing::RR-0001::Edit::2026-08-10T14:55:00',
    sourceModuleRef: 'configuration_routing',
    sourceItemRef: 'RR-0001',
  },
  {
    changeId: 'CHG-010483',
    changedOn: '10 Aug 2026, 1:40 pm',
    changedOnIso: '2026-08-10T13:40:00',
    module: 'Posts',
    changedItem: 'Roof Inspection Special',
    itemId: 'POST-004650',
    changeType: 'Take Down',
    previousValues: NA,
    newValues: NA,
    changeReason: CHANGE_HISTORY_DISPLAY.NOT_REQUIRED,
    changedBy: 'Business — Jordan Lee',
    activityDetails: 'Post moved to recycle bin',
    sourceChangeRef: 'posts_management::POST-004650::Take Down::2026-08-10T13:40:00',
    sourceModuleRef: 'posts_management',
    sourceItemRef: 'POST-004650',
  },
  {
    changeId: 'CHG-010482',
    changedOn: '10 Aug 2026, 11:15 am',
    changedOnIso: '2026-08-10T11:15:00',
    module: 'Configuration — Permissions & Access',
    changedItem: 'Support Officer Permission Configuration',
    itemId: 'PERM-0001',
    changeType: 'Edit',
    previousValues: 'Permissions: View; Assign',
    newValues: 'Permissions: View; Assign; Review',
    changeReason: 'Add the approved Review permission',
    changedBy: 'Platform Owner — Saim Sahi',
    activityDetails: NA,
    sourceChangeRef: 'permissions::PERM-0001::Edit::2026-08-10T11:15:00',
    sourceModuleRef: 'configuration_permissions',
    sourceItemRef: 'PERM-0001',
  },
  {
    changeId: 'CHG-010481',
    changedOn: '9 Aug 2026, 5:20 pm',
    changedOnIso: '2026-08-09T17:20:00',
    module: 'Settings',
    changedItem: 'Regional Defaults — Timezone',
    itemId: NA,
    changeType: 'Edit',
    previousValues: 'Timezone: Australia/Sydney',
    newValues: 'Timezone: Australia/Melbourne',
    changeReason: 'Align Admin timestamps with the confirmed operating timezone',
    changedBy: 'Platform Owner — Saim Sahi',
    activityDetails: NA,
    sourceChangeRef: 'settings::regional_timezone::Edit::2026-08-09T17:20:00',
    sourceModuleRef: 'settings',
    sourceItemRef: 'regional_timezone',
  },
];
